module.exports = __webpack_public_path__ + "static/media/Leak.8961a1d7.svg";